<section class="d-flex flex-column">
  <label *ngIf="typeCall" class="title-forms">Cantidad</label>
  <div
    class="d-flex flex-column container-input"
    [ngClass]="{
      'align-items-start': typeCall
    }"
  >
    <div class="cont-quantity">
      <button
        *ngIf="!isTabla"
        [id]="id + '-remove'"
        mat-button
        class="col-2"
        (click)="remove()"
      >
        -
      </button>
      <input
        *ngIf="!isTabla "
        name="number"
        [id]="id"
        class="col-8 input-quantity"
        [formControl]="quantityControl"
        required
        autocomplete="off"
      />
      <button
        *ngIf="!isTabla "
        [id]="id + '-add'"
        mat-button
        class="col-2"
        (click)="add()"
      >
        +
      </button>      
      <mat-form-field
      [ngClass]="{'input-table': isTabla && !isMaterial}"
      *ngIf="isTabla  || isMaterial"
      >
      <mat-label>{{isMaterial ? 'Ingrese la cantidad de productos *' : ''}}</mat-label>
        <input matInput name="number"
        [id]="id"
        [formControl]="quantityControl"
        [min]='1'
        [max]='available'
        autocomplete="off"
        (blur)="defect($event)"
        (keypress)="validateInput($event)"
        >
        <mat-error class="mat-error">Ingrese la cantidad correctamente</mat-error>
      </mat-form-field>
    </div>
    <mat-error *ngIf="quantityControl.invalid && !isTabla" class="error-component"
      >Cantidad Inválida</mat-error
    >
  </div>
</section>
